import {
    QueryClient,
} from '@tanstack/react-query'

import {
    ApiError,
} from '@/shared/api'

function shouldRetryQuery(
    failureCount: number,
    error: Error,
): boolean {
    if (error instanceof ApiError) {
        /*
         * Never retry client errors:
         * 400, 401, 403, 404, 422, etc.
         */
        if (
            error.status &&
            error.status >= 400 &&
            error.status < 500
        ) {
            return false
        }
    }

    /*
     * Retry network errors and 5xx responses once.
     */
    return failureCount < 1
}

export const queryClient =
    new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30_000,

                retry: shouldRetryQuery,

                refetchOnWindowFocus: false,

                refetchOnReconnect: true,
            },

            mutations: {
                /*
                 * Never automatically retry
                 * potentially state-changing
                 * operations.
                 */
                retry: false,
            },
        },
    })